<template>
    <div id="stu">
        <loadings v-if="loading"></loadings>
        <template v-else>
            <headers :title="title"></headers>
            <div id="chart">
                <div class="box">
                    <h3><i class="score"></i>班级得分率分布</h3>
                    <div id="main0"
                         style="width:15rem; height: 10.5rem;"
                         class="chart"></div>
                </div>
                <div class="box">
                    <h3><i></i>知识点掌握率</h3>
                    <div class="scoreChartWarp">
                        <div id="main1"
                             :style="echartStyle"
                             class="chart"></div>
                    </div>
                </div>
            </div>
            <template v-if="question.length">
                <!-- <mathCom :questions="question" :sid="sid" v-if="sid==21||sid==22"></mathCom>
                <english :questions="question" :sid="sid" v-else-if="sid==91||sid==92"></english>
                <chinese :questions="question" :sid="sid" v-else></chinese> -->
            </template>
            <template v-else>
                <div class="nodata">
                    <noResouse :text="'暂无试题'"></noResouse>
                </div>
            </template>
        </template>
    </div>
</template>

<script>
import * as echarts from 'echarts';
import headers from "COMPONENTS/base/header.vue";
import noResouse from 'COMPONENTS/noResouse.vue';
import loadings from "COMPONENTS/base/loadingS.vue";
// import chinese from "../work/chinese/detail.vue";
// import english from "../work/english/detail.vue";
// import mathCom from "../work/math/detail.vue";
export default {
    components: {
        // simpleResult,
        loadings,
        noResouse,
        headers,
        // chinese,
        // english,
        // mathCom
    },
    data () {
        return {
            title: this.$route.query.name,
            cid: this.$route.query.cid,
            sid: this.$route.query.sid,
            userId: this.$route.query.userId,
            loading: false,
            question: [],
            yData_knowledge: [],
            yData_score: [],
            xData_knowledge: [],
            haveMore: true,
            array: [],
            echartStyle: {
                width: '15rem',
                height: '10.5rem'
            },
            lineArray: [],
            score: this.$route.query.score,
            rate: this.$route.query.rate,
        }
    },
    created () {
        this.array = JSON.parse(localStorage.getItem('teaTaskUnitData'));
        this.$http.post(API_URL_ZNZY_API + '/tea/catalog_unit_user_detail/', { sid: this.sid, cid: this.cid, user_id: this.userId }).then(res => {
            if (res.data.response == 'ok') {
                res = res.data;
                let list = res.data.k_list;
                this.question = res.data.q_list;
                list.forEach(e => {
                    this.xData_knowledge.push(e.name);
                    this.yData_knowledge.push(e.score);
                    let num = Math.ceil(e.name.length / 3);
                    this.lineArray.push(num);
                });

                if (this.xData_knowledge.length) {
                    let n = Math.ceil(this.xData_knowledge.length / 8);
                    this.echartStyle.width = Number(15 * n) + 'rem';
                    let num = Math.max(...this.lineArray);
                    this.echartStyle.height = Number(10.5 + 0.5 * num) + 'rem';
                }
                this.$nextTick(() => {
                    this.initChart()
                })
            }
        });

    },
    mounted () {

    },
    methods: {
        setIndex (score) {
            let num = score == 0 ? 0 : parseInt(score / 20);
            if (score == 100) {
                num = 4;
            }
            return num;
        },
        initChart () {
            let _this = this;
            let xNum = _this.setIndex(_this.score);
            //console.log(xNum)
            let option = {
                grid: {
                    left: '0.5rem',
                    right: '10%',
                    bottom: '3rem',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: ['0%-20%', '20%-40%', '40%-60%', '60%-80%', '80%-100%'],
                    axisLabel: {
                        interval: 0,
                        textStyle: {
                            fontSize: '10'      //更改坐标轴文字大小
                        }
                    }
                },
                yAxis: {
                    type: 'value'
                },
                series: []
            };
            let series = {
                0: [{
                    data: _this.array,
                    type: 'line',
                    areaStyle: {
                        opacity: 0.6,
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {
                                offset: 0,
                                color: '#85aefd'
                            },
                            {
                                offset: 1,
                                color: '#d8e5fe'
                            }
                        ])
                    },
                    markPoint: {
                        data: [
                            {
                                name: '我',
                                xAxis: xNum,
                                yAxis: _this.array[xNum],
                                label: { formatter: function () { return '我' } }
                            }
                        ]
                    },
                    markLine: {
                        data: [
                            {
                                symbol: 'none',
                                xAxis: option.xAxis.data[_this.setIndex(_this.rate)],
                                label: {
                                    formatter: function () { return '班级平均' }
                                }
                            }
                        ]
                    },
                }],
                1: [{
                    data: _this.yData_knowledge,
                    type: 'bar'
                }]
            };
            let data = {
                0: ['0%-20%', '20%-40%', '40%-60%', '60%-80%', '80%-100%'],
                1: _this.xData_knowledge
            }
            for (let i = 0; i < 2; i++) {
                // 基于准备好的dom，初始化echarts实例
                let myChart = echarts.init(document.getElementById("main" + i));
                if (i == 0) {
                    option.xAxis.boundaryGap = false
                    option.yAxis = {
                        type: 'value',
                        min: 0,
                        // max: 100,
                        interval: 20,
                        axisLabel: {
                            formatter: '{value}人'
                        }
                    }
                } else {
                    option.yAxis = {
                        type: 'value',
                        min: 0,
                        max: 100,
                        interval: 20,
                        axisLabel: {
                            formatter: '{value}%'
                        }
                    }
                    option.xAxis.boundaryGap = true
                    option.xAxis.axisLabel = {
                        interval: 0,
                        //  rotate:45
                        formatter: function (value) {
                            var ret = "";//拼接加\n返回的类目项  
                            var maxLength = 3;//每项显示文字个数  
                            var valLength = value.length;//X轴类目项的文字个数  
                            var rowN = Math.ceil(valLength / maxLength); //类目项需要换行的行数  
                            _this.lineArray.push(rowN);
                            if (rowN > 1)//如果类目项的文字大于5,  
                            {
                                for (var i = 0; i < rowN; i++) {
                                    var temp = "";//每次截取的字符串  
                                    var start = i * maxLength;//开始截取的位置  
                                    var end = start + maxLength;//结束截取的位置  
                                    //这里也可以加一个是否是最后一行的判断，但是不加也没有影响，那就不加吧  
                                    temp = value.substring(start, end) + "\n";
                                    ret += temp; //凭借最终的字符串  
                                }
                                return ret;
                            }
                            else {
                                return value;
                            }
                        },
                        textStyle: {
                            fontSize: '10'      //更改坐标轴文字大小
                        }
                    };
                    option.grid.right = '0.5rem';
                }
                option.series = series[i];
                option.xAxis.data = data[i];
                myChart.setOption(option);
            }
        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.box {
    width: 600px / $ppr;
    margin: 0 auto 30px / $ppr;
    background: #fff;
    padding: 30px / $ppr 30px / $ppr 46px / $ppr;
    border-radius: 16px / $ppr;
    h3 {
        font-size: 30px / $ppr;
        margin-bottom: 24px / $ppr;
        line-height: 56px / $ppr;
        padding-left: 48px / $ppr;
        font-weight: bold;
        position: relative;
        i {
            position: absolute;
            display: block;
            top: 50%;
            left: 0;
            margin-top: -17px / $ppr;
            width: 32px / $ppr;
            height: 32px / $ppr;
            background: url("./img/icon03.png") 0 0 no-repeat;
            background-size: 100% 100%;
            // vertical-align: middle;
            // margin-right:16px/$ppr;
        }
        i.score {
            background: url("./img/icon04.png") 0 0 no-repeat;
            background-size: 100% 100%;
        }
    }
}
#chart {
    margin-top: 30px / $ppr;
}
.nodata {
    width: 660px / $ppr;
    margin: 0 auto;
}
.scoreChartWarp {
    width: 600px / $ppr;
    margin: 0 auto;
    overflow-x: auto;
}
</style>